import { render, staticRenderFns } from "./ModalEnviarManual.vue?vue&type=template&id=458a127a&"
import script from "./ModalEnviarManual.vue?vue&type=script&lang=js&"
export * from "./ModalEnviarManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports